import { useBulkSendSmsMutation } from "@js/apps/freelancer/api";
import {
  BulkSendSmsModal,
  type BulkSmsRecipient,
} from "@js/apps/freelancer/components/bulk-send-sms-modal";
import styles from "@js/apps/freelancer/components/bulk-send-sms-modal/bulk-send-sms-modal.module.scss";
import { ModalInstance } from "@js/components/modal";
import type { EmployerBidListBid } from "@js/types/jobs";

type OpenBidsBulkSendSmsModalProps = {
  selectedBids: EmployerBidListBid[];
  jobUrl: string;
};

const toRecipients = (
  selectedBids: EmployerBidListBid[],
): BulkSmsRecipient[] => {
  return selectedBids.map((bid) => ({
    freelancerId: bid.freelancer.id,
    publicName: bid.freelancer.user.public_name,
    hasPhone: Boolean(bid.freelancer.has_phone_number),
    hasValidPhone: Boolean(bid.freelancer.has_valid_phone_number),
    hasConsent: Boolean(bid.freelancer.employment_contact_consented),
  }));
};

const BidsBulkSendSmsModal = ({
  recipients,
  jobUrl,
}: {
  recipients: BulkSmsRecipient[];
  jobUrl: string;
}) => {
  const [bulkSendSms] = useBulkSendSmsMutation();

  return (
    <BulkSendSmsModal
      recipients={recipients}
      jobUrl={jobUrl}
      onSend={async ({ message, freelancerIds, jobUrl: selectedJobUrl }) => {
        return bulkSendSms({
          message,
          freelancer_ids: freelancerIds,
          job_url: selectedJobUrl,
        }).unwrap();
      }}
    />
  );
};

export const openBidsBulkSendSmsModal = ({
  selectedBids,
  jobUrl,
}: OpenBidsBulkSendSmsModalProps) => {
  ModalInstance.open({
    children: (
      <BidsBulkSendSmsModal
        recipients={toRecipients(selectedBids)}
        jobUrl={jobUrl}
      />
    ),
    padding: false,
    closeButton: false,
    className: styles.modal,
  });
};
